import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Links from '../components/Links.vue'
import Contact from '../components/Contact.vue'
import About from '../components/About.vue'
import Newest from '../components/Newest.vue'
import Gallery from '../components/Gallery.vue'
import GalleryOverview from '../components/GalleryOverview.vue'
import Dashboard from '../components/Dashboard.vue'
import Studio from '../components/Studio.vue'
import Award from '../components/Award.vue'
import Home from '../components/Home.vue'
import Login from '../components/Login.vue'
import NewApi from '../ts/api'
import {Token} from '../api/index'

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/links',
    name: 'Links',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Links,
  },
  {
    path: '/contact',
    name: 'Contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Contact,
  },
  {
    path: '/newest',
    name: 'Newest',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Newest,
  },
  {
    path: '/studio',
    name: 'Studio',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Studio,
  },
  {
    path: '/galleries/detail',
    name: 'Gallery',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Gallery,
    props: (route) => ({ id: route.query.id,
    portfolio: (route.query.portfolio === 'true') })
  },
  {
    path: '/galleries',
    name: 'GalleryOverview',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: GalleryOverview,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Dashboard,
    beforeEnter: (to, from, next) => {
      isAuthenticated().then(r=>next()).catch(r => next({ name: 'Login' }))
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: About,
  },
  {
    path: '/awards',
    name: 'Awards',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Award,
    props: (route) => ({ id: route.query.id})
  },  
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Login,
  },
];

const router = new VueRouter({
  mode: 'hash',
  routes,
  base: process.env.BASE_URL,
});

router.beforeEach((to, from, next) => {
  if (to.name === 'Dashboard'){
    isAuthenticated().then(r=>next()).catch(r => next({ name: 'Login' }))
  }else{
    next()
  }
})

async function isAuthenticated(){
  let t = localStorage.getItem("token")
  
  if(t == null || t === ""){
    return false
  }

  let api = NewApi()
  let tokenObj = {} as Token
  tokenObj.token = t
  
  let res = await api.tokenPost(tokenObj)
  console.log("figgerei bullshit shatitus: " + res.status)
  
}

export default router;
